var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details" }, [
    _c("div", { staticClass: "nuv" }, [
      _c(
        "a",
        { staticClass: "active", attrs: { href: "/tjkStudy/courseList" } },
        [_vm._v("培训课程")]
      ),
      _vm._v(">"),
      _c("span", [_vm._v(_vm._s(_vm.courseDetail.courseName))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "left leftcour" }, [
        _c("div", { staticClass: "details-box clear" }, [
          _c("div", {
            staticClass: "zoomImage",
            style: _vm.style(_vm.courseDetail.iconUrl)
          }),
          _vm._v(" "),
          _c("div", { staticClass: "txt txt-over course-txt" }, [
            _c("h2", [_vm._v(_vm._s(_vm.courseDetail.courseName))]),
            _vm._v(" "),
            _c("div", { staticClass: "iconfont icon-yuyue1 text-float" }, [
              _c("span", [
                _c("i", [_vm._v(_vm._s(_vm.courseDetail.lessonPeriod))]),
                _vm._v("学时")
              ]),
              _c("span", [_vm._v("|")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "iconfont icon-people text-float" }, [
              _c("span", [
                _vm._v("已有"),
                _c("i", [_vm._v(_vm._s(_vm.courseDetail.totalUserNum))]),
                _vm._v("人学习")
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "join",
                on: {
                  click: function($event) {
                    return _vm.startStudyCourse()
                  }
                }
              },
              [
                _vm._v("立即学习"),
                _vm.courseDetail.isDone == "yes" ? [_vm._v("(已学)")] : _vm._e()
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "present", attrs: { id: "present" } }, [
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.courseDetail.description) }
            })
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "top-head", attrs: { href: "javascript:;" } },
            [_vm._v("课程目录")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "catalog", attrs: { id: "catalog" } }, [
            _c(
              "ul",
              _vm._l(_vm.materialList, function(m, key) {
                return _c(
                  "li",
                  {
                    class: { active: (key + 1) % 2 },
                    on: {
                      click: function($event) {
                        return _vm.studyCourse(
                          m.materialId,
                          m.courseId,
                          _vm.courseDetail.courseName
                        )
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "order" }, [
                      _vm._v(_vm._s(key + 1) + "、")
                    ]),
                    _c("img", {
                      staticClass: "resType",
                      attrs: { src: m.resTypeUrl }
                    }),
                    _c("span", [_vm._v(_vm._s(m.catalogName))]),
                    m.duration != null
                      ? _c("time", [
                          _vm._v(
                            "(" + _vm._s(_vm.formatSeconds(m.duration)) + ")"
                          )
                        ])
                      : _vm._e(),
                    m.isDone == "yes"
                      ? _c("div", { staticClass: "complete" }, [
                          _vm._v("已完成")
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("h4", { attrs: { title: "学习该课程的学员" + _vm.keys } }, [
          _vm._v("学习该课程的学员（" + _vm._s(_vm.keys) + "）")
        ]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.info, function(infos) {
            return _c("li", [
              _c("img", {
                staticClass: "head",
                attrs: { src: infos.userIcon }
              }),
              _vm._v(" "),
              _c("p", { attrs: { title: infos.loginName } }, [
                _vm._v(_vm._s(infos.loginName))
              ])
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cat-head" }, [
      _c("a", { staticClass: "active", attrs: { href: "#present" } }, [
        _vm._v("课程介绍")
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "#catalog" } }, [_vm._v("课程目录")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bff997a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bff997a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/courseDetail.vue
// module id = 1108
// module chunks = 0